<template>
  <div>
    <div class="container">
      <div class="header">
        <img class="header__avatar" v-if="!!member" :src="member.avatar_url"/>
        <h1 class="header__copy" v-if="!!member">
          {{member.username}}, <br /> let's build a better you.
        </h1>
      </div>
      <img src="../assets/img/Web_SelectPlan_blurb.png" />
      <div id="apple-pay-container">
        <button id="apple-pay-button">
          <img v-on:click="selectApplePay(selectedPlan)" src="../assets/img/Button_Apple_Pay.png"/>
        </button>
        <img style="max-width:65%" src="../assets/img/Web_Payment_Or_Securely_Enter.png" />
      </div>
      <div>
        <img id="securly-enter-blurb" style="max-width:65%" src="../assets/img/Web_Payment_Securely_Enter.png" />
        <card class='stripe-card' :class='{ complete }' :stripe='stripeKey' :options='stripeOptions' @change='complete = $event.complete' />
        <button class='pay-with-stripe' @click='pay' :disabled='processing'>
          <img src="../assets/img/Button_Start_My_Free_Trial.png"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* global Stripe */
import {
  Card,
  createToken
} from 'vue-stripe-elements-plus'

export default {
  name: 'Payment',
  props: ['member', 'stripe-key', 'selected-plan'],
  data () {
    return {
      self: this,
      complete: false,
      processing: false,
      stripeOptions: {
        style: {
          base: {
            color: '#FF0066',
            fontWeight: 500,
            fontFamily: 'Avenir',
            textTransform: 'uppercase',
            fontSize: '16px',
            fontSmoothing: 'antialiased',

            '::placeholder': {
              color: '#666'
            },
            ':-webkit-autofill': {
              color: '#e39f48'
            }
          }
        }
        // see https://stripe.com/docs/stripe.js#element-options for details
      }
    }
  },
  components: {
    Card
  },
  methods: {
    selectApplePay (selectedPlan) {
      let paymentRequest = {
        countryCode: 'US',
        currencyCode: 'USD',
        total: {
          label: selectedPlan.id,
          amount: selectedPlan.revenue
        }
      }
      return new Promise((resolve, reject) => {
        const session = Stripe.applePay.buildSession(paymentRequest, (result, completion) => {
          resolve({ result, completion })
          // eslint-disable-next-line
          completion(ApplePaySession.STATUS_SUCCESS)
          console.log(result, completion)
          this.$emit('next', {token: result.token, method: 'ApplePay'})
        }, (err) => {
          reject(err)
        })

        session.oncancel = function () {
          console.log('User hit the cancel button in the payment window')
          reject(new Error('Apple pay canceled.'))
        }

        session.begin()
      })
    },
    pay () {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      this.processing = true
      createToken().then(result => {
        if (!result.error) {
          this.next({token: result.token, method: 'CreditCard'})
        } else {
          this.processing = false
          console.log('Error:' + result.error)
        }
      })
    },
    next (type) {
      this.$emit('next', type)
    }
  },
  mounted () {
    Stripe.setPublishableKey(this.stripeKey)
    Stripe.applePay.checkAvailability(function (available) {
      if (available) {
        document.getElementById('apple-pay-container').style.display = 'block'
        document.getElementById('securly-enter-blurb').style.display = 'none'
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.screen {
  background: url('../assets/img/vignette.png'),
              url('../assets/img/Background_Pay.jpg');
  background-position: center center, 70% 0;
  background-size: cover, cover;
  background-repeat: repeat, no-repeat;
}

@media only screen and (min-width: 320px)
       and (max-width: 667px)
       and (-webkit-min-device-pixel-ratio: 2) {

  .screen {
    background: url('../assets/img/vignette.png'),
                url('../assets/img/Background_Pay_s.jpg');
    background-position: center center, 70% 0;
    background-size: cover, cover;
    background-repeat: repeat, no-repeat;
  }
}
.container {
  height: 100vh;
  max-height: 450px;
  justify-content: space-between;
}

.header {
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  display: block;

}

.header__copy {
  text-align: left;
  line-height: 125%;
}

.header__avatar {
  border-radius: 100%;
  flex: 1;
  width: 100px;
  height: 100px;
  margin: 5px 15px 5px 0;
}

.plans-container img {
  margin: 10px 0;
}

.stripe-card {
  /* max-width: 70%; */
  margin: 10px 20px 20px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}

.stripe-card.complete {
  border-color: green;
}

#apple-pay-container {
  display: none;
  margin: 10px 0;

}
</style>



// WEBPACK FOOTER //
// src/components/Payment.vue